import React from 'react';
import Label from '../Label/Label';
import 'react-datepicker/dist/react-datepicker.css';
// @ts-ignore
import styles from './Select.module.scss';
import { default as ReactSelect } from 'react-select';
import { useValidation } from '../../Utils/Validation';
import { FieldError } from 'react-hook-form';
import useTranslation from '../../../Hooks/useTranslation';
import { firstUpperString } from '../../FirstUpper';
import ErrorMessage from '../../Form/components/ErrorMessage';

interface ISelect {
	onChange?: any;
	onChangeExtra?: any;
	onFocus?: any;
	placeholder?: string;
	required?: boolean;
	value?: SelectValue | string;
	label?: string;
	firstUpper?: boolean;
	className?: string;
	options: any;
	isSearchable?: boolean;
	error?: FieldError;
	returnKey?: string;
	translate?: boolean;
	disabled?: boolean;
	isMulti?: boolean;
	components?: object;
	closeMenuOnSelect?: boolean;
	hideSelectedOptions?: boolean;
	isClearable?: boolean;
	portal?: boolean;
	firstUpperValues?: boolean;
	filterOption?: any;
	showErrorMessage?: boolean;
	noOptionsMessage?: string;
}

export interface SelectValue {
	value: string | number | object;
	label: string;
}

export default function Select(props: ISelect) {
	const {
		label,
		onChange,
		onChangeExtra,
		onFocus,
		placeholder = 'base.shared.pick',
		required = false,
		value,
		firstUpper = false,
		firstUpperValues = false,
		className,
		options,
		error,
		isSearchable = false,
		returnKey,
		translate,
		disabled,
		isMulti = false,
		components = {},
		closeMenuOnSelect,
		hideSelectedOptions,
		isClearable = false,
		portal = false,
		filterOption,
		showErrorMessage = true,
		noOptionsMessage = 'base.noOptions',
	} = props;
	const { fillErrorMessage } = useValidation();
	const { t } = useTranslation();

	const translateOptions = (options: any): any => {
		if (firstUpperValues) {
			return options?.map((option: any) => ({
				...option,
				label: firstUpperString(t(option.label) ?? ''),
			}));
		}
		return options?.map((option: any) => ({
			...option,
			label: t(option.label),
		}));
	};

	const handleOnChange = e => {
		let val = e;
		if (returnKey) {
			val = val[returnKey] || val;
		}

		onChange?.(val);
		onChangeExtra?.(val);
	};

	const translatedOptions = translateOptions(options);

	return (
		<div className={styles.wrapper}>
			{label && <Label tx={label} firstUpper={firstUpper} />}
			{/*className={error && error.value && styles.invalid}*/}
			<ReactSelect
				isMulti={isMulti}
				value={
					typeof value === 'object'
						? value
						: translatedOptions?.find(o => o.value == value)
				}
				className={error && (error?.value || error?.message) && 'invalid'}
				defaultValue={
					typeof value === 'object'
						? value
						: translatedOptions?.find(o => o.value == value)
				}
				options={translatedOptions}
				classNamePrefix={'reactSelect'}
				styles={
					error
						? {
								control: () => ({
									borderColor: 'red !important',
								}),
						  }
						: undefined
				}
				isSearchable={isSearchable}
				placeholder={t(placeholder)}
				onChange={handleOnChange}
				menuPosition='absolute'
				isDisabled={disabled}
				components={components}
				closeMenuOnSelect={closeMenuOnSelect}
				hideSelectedOptions={hideSelectedOptions}
				isClearable={isClearable}
				menuPortalTarget={portal ? document.body : null}
				noOptionsMessage={() => t(noOptionsMessage)}
				filterOption={filterOption}
			/>
			{error?.message && showErrorMessage && (
				<ErrorMessage tx={error?.message} />
			)}
		</div>
	);
}
